const calcIconSize = (diffX, diffY, size, max, min) => {
  const delta = Math.abs(diffX) >= Math.abs(diffY) ? diffX : diffY;
  return Math.min(Math.max(size + delta, min), max);
};

export default calcIconSize;
